export default "__VITE_PUBLIC_ASSET__15477328__"